import React from 'react'
import NavigationBar from '../Components/GlobalComponents/Navbar'
import ExternalSlider from '../Components/ExternalComponents/ExternalSlider'

const ExternalSelection = () => {
  return (
    <div
    style={{
      backgroundColor:"#1a1a1a",
      height:"100vh"
    }}
    >
      <NavigationBar/>
      <ExternalSlider/>
    </div>
  )
}

export default ExternalSelection
